import React from "react";
import { Nav, Navbar, Form } from 'react-bootstrap';
import Css from './Layout.module.css';

export default function Footer4Bottom2() {
    return (
        <div className={`${Css.Footer_Bottom2}`}>
            <label className="d-block text-center">© Copyright 2022. Magic Software (Thailand) Corp., Ltd. - All Rights Reserved. Version : {process.env.REACT_APP_VERSION}</label>
        </div>
    )
}